import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button } from "reactstrap";
import Header from "../../layout/Header/Header";

function BotonesReportesBI() {
  const { user } = useContext(AuthContext);

  const reportes = [
    { href: "/ReporteVentasArticuloMP", icon: "fas fa-calendar-day", label: "Reporte Ventas Diario" },
    { href: "/ReporteMasterCostos", icon: "fas fa-dollar-sign", label: "Master Costos" },
    { href: "/ReporteVentasArticulo", icon: "fas fa-boxes", label: "Reporte Ventas Articulo" },
    { href: "/ListadoInventariosCostos", icon: "fas fa-warehouse", label: "Inventario Costos" },
    { href: "/ReporteVariacionInventario", icon: "fas fa-sync-alt", label: "Variacion de Inventario" },
    { href: "/ReporteUtilidad", icon: "fas fa-percent", label: "Calculo de Utilidad" },
  ];

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_reportes ? (
        <div className="container">
          <h3 align="center">Reportes Business Intelligence</h3>
          <br />
          <Row>
            {reportes.map((r) => (
              <Col md={4} align="center" key={r.href} style={{ marginBottom: "24px" }}>
                <Button href={r.href} className="botonesMenu" color="success">
                  <i className={`${r.icon} fa-7x`}></i>
                  <br />
                  <br />
                  {r.label}
                </Button>
              </Col>
            ))}
          </Row>
        </div>
      ) : undefined}
    </>
  );
}

export default BotonesReportesBI;
